import React, { Component } from "react";

export default class SubmitButton extends Component {
  render() {
    return (
      <div className="row save-btn">
        <div className="float-right">
          <button
            onClick={this.props.onClick}
            disabled={this.props.isDisabled}
            className="btn btn-primary"
            id="saving_button"
            type="button"
          >
            Submit
          </button>
        </div>
      </div>
    );
  }
}
